// extracted by mini-css-extract-plugin
export default {"moreFromHlf":"moreFromHlf__moreFromHlf--hpsnM","moreFromHlfTitle":"moreFromHlf__moreFromHlfTitle--op22v"};